import { OptionalStateCarts } from '../CartsState';
import { RootState } from '../../RootState';

const selectCarts = ({ carts: { carts } }: RootState): OptionalStateCarts => carts;

export default selectCarts;
